const API_BASE_URL = import.meta.env.VITE_PERPIX_API_URL;

if (!API_BASE_URL) {
  throw new Error("VITE_PERPIX_API_URL is not defined");
}

export const APP_KEYS = {
  LOCAL_STORAGE: {
    GLOBAL_JOTAI_ATOM: "global-state",
    FILES_PREVIEW: "files-preview",
    EDITOR_SETTINGS: "editor-settings",
  },
  API_BASE_URL,
} as const;
